import { render, staticRenderFns } from "./ImagePicker.vue?vue&type=template&id=4f24b9fb&"
import script from "./ImagePicker.vue?vue&type=script&lang=ts&"
export * from "./ImagePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports